import { Theme } from 'common';

export const Pin = ({ height = 30, width = 22 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 0C4.9236 0 0 4.18199 0 9.3621C0 18.3189 11 30 11 30C11 30 22 18.3171 22 9.3621C22 4.18386 17.0764 0 11 0V0ZM11 14.5422C9.42461 14.5422 7.91375 14.0085 6.79979 13.0585C5.68582 12.1085 5.06 10.82 5.06 9.47655C5.06 8.13305 5.68582 6.84458 6.79979 5.89458C7.91375 4.94458 9.42461 4.41088 11 4.41088C12.5754 4.41088 14.0862 4.94458 15.2002 5.89458C16.3142 6.84458 16.94 8.13305 16.94 9.47655C16.94 10.82 16.3142 12.1085 15.2002 13.0585C14.0862 14.0085 12.5754 14.5422 11 14.5422Z" fill={Theme.Svg.ColorDefault}/>
    </svg>
  );
};